/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import FloatingWindowsManagerInstance from "FloatingWindow/FloatingWindowsManager";

export const getFloatingWindowsApis = stores => {
  const instance = FloatingWindowsManagerInstance;

  /***
   * params: IFloatingWindowManagerParams
   */
  function addWindow(params) {
    return instance.addWindow(params);
  }

  return {
    addWindow
  };
};

export const registerFloatingWindowsApis = stores => {
  apiFactory.registerApi(
    publicApiNames.FLOATING_WINDOWS,
    clientName => getFloatingWindowsApis(stores),
    true /* isNew */
  );
};
